import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Truck, Package, MapPin, Clock, CheckCircle, TrendingUp, DollarSign, Activity, Phone, Navigation, AlertCircle } from 'lucide-react';
export function LogisticsDashboard() {
  const activeShipments = [{
    id: 'PO-2023-001',
    trackingNumber: 'JNE88291002',
    cooperative: 'Koperasi Maju Jaya',
    destination: 'Bogor, Jawa Barat',
    items: 32,
    weight: 160,
    status: 'in_transit',
    currentLocation: 'Gudang Transit Bogor',
    eta: 'Besok, 14:00 WIB',
    progress: 75,
    driver: 'Ahmad Yani',
    driverPhone: '+62 812-9999-8888',
    vehicle: 'B 1234 XYZ'
  }, {
    id: 'PO-2023-004',
    trackingNumber: 'JNE88291005',
    cooperative: 'Koperasi Sejahtera',
    destination: 'Bandung, Jawa Barat',
    items: 28,
    weight: 140,
    status: 'in_transit',
    currentLocation: 'Dalam Perjalanan',
    eta: 'Hari ini, 16:00 WIB',
    progress: 60,
    driver: 'Budi Santoso',
    driverPhone: '+62 813-8888-7777',
    vehicle: 'B 5678 ABC'
  }];
  return <div className="space-y-6" data-id="element-2337">
      {/* Header */}
      <div data-id="element-2338">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-2339">
          Dashboard Logistik
        </h2>
        <p className="text-sm text-slate-500 mt-1" data-id="element-2340">
          Monitor pengiriman dan performa kurir real-time
        </p>
      </div>

      {/* KPIs */}
      <div className="grid grid-cols-4 gap-4" data-id="element-2341">
        <Card className="p-5 bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" data-id="element-2342">
          <div className="flex items-center justify-between mb-3" data-id="element-2343">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-2344">
              <Truck className="w-6 h-6 text-white" data-id="element-2345" />
            </div>
            <Badge className="bg-blue-200 text-blue-800 border-0" data-id="element-2346">Aktif</Badge>
          </div>
          <p className="text-sm text-blue-700 mb-1" data-id="element-2347">Pengiriman Aktif</p>
          <p className="text-4xl font-bold text-blue-900" data-id="element-2348">18</p>
          <p className="text-xs text-blue-600 mt-1" data-id="element-2349">Dalam perjalanan</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-green-50 to-green-100 border-green-200" data-id="element-2350">
          <div className="flex items-center justify-between mb-3" data-id="element-2351">
            <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-2352">
              <CheckCircle className="w-6 h-6 text-white" data-id="element-2353" />
            </div>
            <Badge className="bg-green-200 text-green-800 border-0" data-id="element-2354">+12</Badge>
          </div>
          <p className="text-sm text-green-700 mb-1" data-id="element-2355">Selesai Hari Ini</p>
          <p className="text-4xl font-bold text-green-900" data-id="element-2356">45</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-2357">On-time: 98%</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-violet-50 to-violet-100 border-violet-200" data-id="element-2358">
          <div className="flex items-center justify-between mb-3" data-id="element-2359">
            <div className="w-12 h-12 bg-violet-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-2360">
              <DollarSign className="w-6 h-6 text-white" data-id="element-2361" />
            </div>
            <Badge className="bg-violet-200 text-violet-800 border-0" data-id="element-2362">
              +18%
            </Badge>
          </div>
          <p className="text-sm text-violet-700 mb-1" data-id="element-2363">Revenue Bulan Ini</p>
          <p className="text-4xl font-bold text-violet-900" data-id="element-2364">Rp 45Jt</p>
          <p className="text-xs text-violet-600 mt-1" data-id="element-2365">1,247 pengiriman</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200" data-id="element-2366">
          <div className="flex items-center justify-between mb-3" data-id="element-2367">
            <div className="w-12 h-12 bg-amber-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-2368">
              <TrendingUp className="w-6 h-6 text-white" data-id="element-2369" />
            </div>
            <Badge className="bg-amber-200 text-amber-800 border-0" data-id="element-2370">Baik</Badge>
          </div>
          <p className="text-sm text-amber-700 mb-1" data-id="element-2371">Success Rate</p>
          <p className="text-4xl font-bold text-amber-900" data-id="element-2372">98.5%</p>
          <p className="text-xs text-amber-600 mt-1" data-id="element-2373">Avg: 2.3 hari</p>
        </Card>
      </div>

      {/* Active Shipments */}
      <Card className="p-6" data-id="element-2374">
        <div className="flex items-center justify-between mb-6" data-id="element-2375">
          <div data-id="element-2376">
            <h3 className="font-bold text-lg text-slate-900" data-id="element-2377">
              Pengiriman Aktif
            </h3>
            <p className="text-sm text-slate-500 mt-1" data-id="element-2378">
              Monitor pengiriman yang sedang berlangsung
            </p>
          </div>
          <div className="flex items-center gap-2 px-3 py-1.5 bg-green-50 border border-green-200 rounded-lg" data-id="element-2379">
            <Activity className="w-4 h-4 text-green-600 animate-pulse" data-id="element-2380" />
            <span className="text-sm font-bold text-green-700" data-id="element-2381">
              Live Tracking
            </span>
          </div>
        </div>

        <div className="space-y-4" data-id="element-2382">
          {activeShipments.map(shipment => <div key={shipment.id} className="p-5 bg-slate-50 rounded-xl border border-slate-200" data-id="element-2383">
              <div className="flex items-start gap-6" data-id="element-2384">
                {/* Status Indicator */}
                <div className="flex-shrink-0" data-id="element-2385">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-2386">
                    <Truck className="w-8 h-8 text-white" data-id="element-2387" />
                  </div>
                </div>

                {/* Shipment Info */}
                <div className="flex-1 min-w-0" data-id="element-2388">
                  <div className="flex items-start justify-between mb-3" data-id="element-2389">
                    <div data-id="element-2390">
                      <div className="flex items-center gap-3 mb-2" data-id="element-2391">
                        <h4 className="text-xl font-bold text-slate-900" data-id="element-2392">
                          {shipment.id}
                        </h4>
                        <Badge variant="warning" data-id="element-2393">Dalam Pengiriman</Badge>
                      </div>
                      <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-2394">
                        <span className="font-mono" data-id="element-2395">
                          {shipment.trackingNumber}
                        </span>
                        <span className="text-slate-400" data-id="element-2396">•</span>
                        <span data-id="element-2397">{shipment.cooperative}</span>
                      </div>
                    </div>
                    <div className="text-right" data-id="element-2398">
                      <p className="text-sm text-slate-600 mb-1" data-id="element-2399">ETA</p>
                      <p className="text-lg font-bold text-blue-600" data-id="element-2400">
                        {shipment.eta}
                      </p>
                    </div>
                  </div>

                  {/* Progress */}
                  <div className="mb-4" data-id="element-2401">
                    <div className="flex justify-between items-center mb-2" data-id="element-2402">
                      <div className="flex items-center gap-2" data-id="element-2403">
                        <MapPin className="w-4 h-4 text-blue-600" data-id="element-2404" />
                        <span className="text-sm font-medium text-slate-900" data-id="element-2405">
                          {shipment.currentLocation}
                        </span>
                      </div>
                      <span className="text-sm font-bold text-slate-900" data-id="element-2406">
                        {shipment.progress}%
                      </span>
                    </div>
                    <div className="w-full h-2 bg-slate-200 rounded-full overflow-hidden" data-id="element-2407">
                      <div className="h-full bg-gradient-to-r from-blue-500 to-blue-600 rounded-full transition-all duration-500" style={{
                    width: `${shipment.progress}%`
                  }} data-id="element-2408"></div>
                    </div>
                  </div>

                  {/* Details */}
                  <div className="flex items-center justify-between pt-4 border-t border-slate-200" data-id="element-2409">
                    <div className="flex items-center gap-6 text-sm" data-id="element-2410">
                      <div className="flex items-center gap-2" data-id="element-2411">
                        <Package className="w-4 h-4 text-slate-400" data-id="element-2412" />
                        <span className="text-slate-600" data-id="element-2413">
                          {shipment.items} Item ({shipment.weight}kg)
                        </span>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-2414">
                        <MapPin className="w-4 h-4 text-slate-400" data-id="element-2415" />
                        <span className="text-slate-600" data-id="element-2416">
                          {shipment.destination}
                        </span>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-2417">
                        <Truck className="w-4 h-4 text-slate-400" data-id="element-2418" />
                        <span className="text-slate-600" data-id="element-2419">
                          {shipment.vehicle}
                        </span>
                      </div>
                    </div>

                    <div className="flex gap-2" data-id="element-2420">
                      <Button variant="outline" size="sm" icon={<Phone className="w-4 h-4" data-id="element-2422" />} data-id="element-2421">
                        Hubungi Driver
                      </Button>
                      <Button variant="primary" size="sm" icon={<Navigation className="w-4 h-4" data-id="element-2424" />} data-id="element-2423">
                        Track Live
                      </Button>
                    </div>
                  </div>

                  {/* Driver Info */}
                  <div className="mt-3 p-3 bg-blue-50 rounded-lg border border-blue-200" data-id="element-2425">
                    <div className="flex items-center justify-between" data-id="element-2426">
                      <div className="flex items-center gap-3" data-id="element-2427">
                        <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold" data-id="element-2428">
                          {shipment.driver.split(' ').map(n => n[0]).join('')}
                        </div>
                        <div data-id="element-2429">
                          <p className="text-sm font-bold text-slate-900" data-id="element-2430">
                            {shipment.driver}
                          </p>
                          <p className="text-xs text-slate-600" data-id="element-2431">
                            {shipment.driverPhone}
                          </p>
                        </div>
                      </div>
                      <Badge variant="success" className="text-xs" data-id="element-2432">
                        Driver Aktif
                      </Badge>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </Card>

      {/* Performance Stats */}
      <div className="grid grid-cols-2 gap-6" data-id="element-2433">
        <Card className="p-6" data-id="element-2434">
          <h3 className="font-bold text-lg text-slate-900 mb-4" data-id="element-2435">
            Performa Pengiriman
          </h3>
          <div className="space-y-4" data-id="element-2436">
            <div data-id="element-2437">
              <div className="flex justify-between items-center mb-2" data-id="element-2438">
                <span className="text-sm text-slate-600" data-id="element-2439">On-Time Delivery</span>
                <span className="text-sm font-bold text-green-600" data-id="element-2440">98.5%</span>
              </div>
              <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-2441">
                <div className="h-full bg-green-500 rounded-full" style={{
                width: '98.5%'
              }} data-id="element-2442"></div>
              </div>
            </div>

            <div data-id="element-2443">
              <div className="flex justify-between items-center mb-2" data-id="element-2444">
                <span className="text-sm text-slate-600" data-id="element-2445">
                  Customer Satisfaction
                </span>
                <span className="text-sm font-bold text-blue-600" data-id="element-2446">4.8/5.0</span>
              </div>
              <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-2447">
                <div className="h-full bg-blue-500 rounded-full" style={{
                width: '96%'
              }} data-id="element-2448"></div>
              </div>
            </div>

            <div data-id="element-2449">
              <div className="flex justify-between items-center mb-2" data-id="element-2450">
                <span className="text-sm text-slate-600" data-id="element-2451">
                  Avg Delivery Time
                </span>
                <span className="text-sm font-bold text-violet-600" data-id="element-2452">
                  2.3 hari
                </span>
              </div>
              <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-2453">
                <div className="h-full bg-violet-500 rounded-full" style={{
                width: '85%'
              }} data-id="element-2454"></div>
              </div>
            </div>
          </div>
        </Card>

        <Card className="p-6" data-id="element-2455">
          <h3 className="font-bold text-lg text-slate-900 mb-4" data-id="element-2456">
            Alerts & Issues
          </h3>
          <div className="space-y-3" data-id="element-2457">
            <div className="flex items-start gap-3 p-3 bg-amber-50 border border-amber-200 rounded-lg" data-id="element-2458">
              <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-2459" />
              <div data-id="element-2460">
                <h4 className="text-sm font-bold text-amber-800" data-id="element-2461">
                  Delayed Shipment
                </h4>
                <p className="text-xs text-amber-600 mt-1" data-id="element-2462">
                  PO-2023-007 terlambat 2 jam dari ETA
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-200 rounded-lg" data-id="element-2463">
              <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-2464" />
              <div data-id="element-2465">
                <h4 className="text-sm font-bold text-green-800" data-id="element-2466">
                  All Systems Normal
                </h4>
                <p className="text-xs text-green-600 mt-1" data-id="element-2467">
                  Tidak ada issue kritis hari ini
                </p>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}